import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import App from "./Components/App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Static/Styles/index.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";

const _store:any = store;
ReactDOM.render(
  <Provider store={_store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
  document.getElementById("root")
);
